import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "pages-result__img-col" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 1,
  class: "pages-result__icon"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "icon-contact-form" }, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.imageUrl)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: $props.imageUrl + '?hei=90',
          alt: $props.title,
          class: "pages-result__img"
        }, null, 8 /* PROPS */, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
  ]))
}